import React from 'react';

import Banner from './components/Banner/Banner';
import BusinessCourses from './components/BusinessCourses/BusinessCourses';
import Tools from '../../components/Tools/Tools';
import Comfortability from '../../components/Comfortability/Comfortability';
import FreeConsultation from '../../components/FreeConsultation/FreeConsultation';
import WeProvideConditions from '../../components/WeProvideConditions/WeProvideConditions';
import Experts from './components/Experts/Experts';
import YourFuture from './components/YourFuture/YourFuture';
import Team from './components/Team/Team';
import Carousel from '../../components/Carousel/Carousel';

import { useScrollToTopOnMount } from '../../hooks/useScrollToTopOnMount';
import { sectionIds } from '../../utils/constants';
import { PagesEnum } from '../../utils/enums';
import { useAccessibility } from '../../contexts/AccessibilityContext';

function Home() {
  useScrollToTopOnMount();
  const {
    settings: { theme },
  } = useAccessibility();

  return (
    <main className='home-page page'>
      <Banner />
      <BusinessCourses id={sectionIds[PagesEnum.Home].courses} theme={theme} />
      <Tools id={sectionIds[PagesEnum.Home].tools} theme={theme} />
      <FreeConsultation
        id={sectionIds[PagesEnum.Home].consultation}
        title='НЕ ЗНАЕШЬ С ЧЕГО НАЧАТЬ? '
        subTitle='ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ'
        description='Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом'
      />
      <Comfortability id={sectionIds[PagesEnum.Home].comfortability} />
      <WeProvideConditions id={sectionIds[PagesEnum.Home].weProvideConditions} />
      <Experts id={sectionIds[PagesEnum.Home].experts} />
      <YourFuture id={sectionIds[PagesEnum.Home].yourFuture} />
      <Team id={sectionIds[PagesEnum.Home].team} />
      <Carousel id={sectionIds[PagesEnum.Home].carousel} />
      <FreeConsultation
        title='НАЧНИ ПРЯМО СЕЙЧАС'
        subTitle='ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ'
        description='Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом'
      />
    </main>
  );
}

export default Home;
